export enum TypeAvisEnum {

    C4_1, C4_2, C4_3, C4_4, C4_5
}
